import { render, staticRenderFns } from "./ReviewText.vue?vue&type=template&id=0ce23e0f&scoped=true&"
import script from "./ReviewText.vue?vue&type=script&lang=js&"
export * from "./ReviewText.vue?vue&type=script&lang=js&"
import style0 from "./ReviewText.vue?vue&type=style&index=0&id=0ce23e0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce23e0f",
  null
  
)

export default component.exports